import React, { useEffect } from 'react'
import Dialog from '@mui/material/Dialog'
import { useForm } from 'react-hook-form'
import CommunityForm from './CreateCommunityPage/CommunityForm'
import { useSnackbar } from 'notistack'
import communityService from '../../services/communityService'

const UpdateCommunityPage = ({ community, open, onClose, submitOnSuccess }) => {
  const { enqueueSnackbar } = useSnackbar()

  const methods = useForm({ mode: 'onChange' })

  useEffect(() => {
    methods.reset({
      id: community.id,
      description: community.description,
      heroImageUrl: community.heroImageUrl
    })
  }, [])

  const submitHandler = ({ id, description, heroImageUrl }) => {
    const form = { id, description, heroImageUrl }
    return communityService.updateCommunity(community.id, {
      ...form
    })
      .then(res => {
        onClose()
        submitOnSuccess()
        enqueueSnackbar('Successfully updated the community!', { variant: 'success' })
      })
      .catch(err => enqueueSnackbar(err.response.data?.message, { variant: 'error' }))
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <CommunityForm methods={methods} onSubmit={submitHandler} onClose={onClose} submitButtonLabel="Update" />
    </Dialog>
  )
}

export default UpdateCommunityPage
